
    <template>
        <section class="flex justify-center items-start mb-10">
            <div class="flex justify-center flex-col mt-4">
                <h1 class="text-gray-700 text-5xl police-title font-bold">{{ title }}</h1>     
                <hr class="border-cv border-2 mt-5 rounded-full">
            </div>
        </section>
    </template>

    <script>
    export default {
        props: {
            title: {
                type: String,
                required: true
            }
        }
    }
    </script>
